import {useProductCategoryList} from '@/hooks/useProductCategoryList'
import {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'

export const useBrandAndCategoryEditHook = ({formData}) => {
  const navigate = useNavigate()
  const brandFields = [
    {
      key: 'brandId',
      label: 'Brand ID',
      placeholder: 'Add Brand ID',
      isDisabled: true,
    },
    {
      key: 'displayBrandId',
      label: 'Display Brand ID',
      placeholder: 'Add Display Brand ID',
    },
    {
      key: 'brandGroupName',
      label: 'Brand Group Name',
      placeholder: 'Add Brand Group Name',
      isDisabled: true,
    },
    {
      key: 'subBrandId',
      label: 'Sub Brand ID',
      placeholder: 'Add Sub Brand ID',
      isDisabled: true,
    },
    {
      key: 'brand',
      label: 'Product Brand',
      placeholder: 'Add Product Brand',
      languages: ['en', 'es_MX', 'lang_country'], // For multilingual fields
      isDisabled: true,
    },
    {
      key: 'displayBrand',
      label: 'Display Brand',
      placeholder: 'Add Display Brand',
      languages: ['en', 'es_MX', 'lang_country'], // For multilingual fields
    },
    {
      key: 'subBrand',
      label: 'Product Sub brand',
      placeholder: 'Add Product Sub brand',
      languages: ['en', 'es_MX', 'lang_country'], // For multilingual fields
      isDisabled: true,
    },
  ]

  const categoryFields = {
    erpCategory: {
      label: 'ERP Category',
      placeholder: 'Add ERP Category',
      isDisabled: true,
    },
    erpCategoryId: {
      label: 'ERP Category ID',
      placeholder: 'Add ERP Category ID',
      isDisabled: true,
    },
    displayCategoryId: {
      label: 'Display Category ID',
      placeholder: 'Add Display Category ID',
    },
    categoryType: {
      label: 'Category Type',
      placeholder: 'Add Category Type',
      isDisabled: true,
    },
    subCategoryId: {
      label: 'Sub Category ID',
      placeholder: 'Add Sub Category ID',
    },
    subCategory: {
      label: 'Sub Category',
      placeholder: 'Add Sub Category'
    },
    displayCategory: {
      label: 'Display Category',
      placeholder: 'Add Display Category',
    },
  }

  const [brandAndCategoryFormData, setBrandAndCategoryFormData] = useState(formData)

  const handleFormChange = data => {
    setBrandAndCategoryFormData(prev => ({...prev, ...data}))
  }

  useEffect(() => {
    if (!formData?.baseData?.productId) navigate(-1)
  }, [formData?.baseData?.productId, navigate])

  // Category list data
  const {categoryListData} = useProductCategoryList()

  return {
    brandFields,
    categoryFields,
    categoryListData,
    brandAndCategoryFormData,
    handleFormChange,
  }
}
